import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'

const defaultGroup = 'F'

/**
 *
 * @returns The current plan pricing group {@link https://app.optimizely.com/v2/projects/17283172040/features/21350400496/rules} , or the default group if the feature is not enabled.
 */
export function usePlanPricingGroup(): string {
  // If a new group goes well, we should make it the new default for times
  // when optimizely is having issues.
  const [enabled, settings] = useFlowFeature('pricing_plan_group')
  return enabled && settings.group ? settings.group : defaultGroup
}
